import { render, staticRenderFns } from "./LettersWithWoodPieces.vue?vue&type=template&id=d4f0e4ec&scoped=true&"
import script from "./LettersWithWoodPieces.vue?vue&type=script&lang=js&"
export * from "./LettersWithWoodPieces.vue?vue&type=script&lang=js&"
import style0 from "./LettersWithWoodPieces.vue?vue&type=style&index=0&id=d4f0e4ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f0e4ec",
  null
  
)

export default component.exports